































import {Component, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTextField from "@/components/Dialog/parts/DialogTextField.vue";
import {Util} from "@/_global/utils";
import MenusStore from "@/store/modules/MenusStore";
import ThemesStore from "@/store/modules/ThemesStore";

@Component({
    components: {
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class AddMenuDialog extends Vue {
    private menuName: string = "";

    private onChange(value: string): void {
        this.menuName = value;
    }

    get newMenu(): CMS.Menu {
        const tmpId: number = Util.getTempId(MenusStore.all);
        const defaultThemeId: number = ThemesStore.defaultThemeId;
        return {
            id: tmpId,
            theme_id: defaultThemeId,
            name: this.menuName,
            store_ids:[]
        };
    }
}
